import { render } from "./EducationSection.vue?vue&type=template&id=c140281c&scoped=true"
import script from "./EducationSection.vue?vue&type=script&lang=js"
export * from "./EducationSection.vue?vue&type=script&lang=js"

import "./EducationSection.vue?vue&type=style&index=0&id=c140281c&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c140281c"]])

export default __exports__